export default "__VITE_ASSET__1ad071ad__"